import React, {
  FC, useEffect, useState,
} from 'react';
import {
  BackgroundImage,
  Button,
} from './Styles';
import Header from '../../../../../Common/Header';
import { Box, Cab } from '../../../../../../../lib/types';
import { getFoodifoxDataLazy, updateFoodifoxData } from '../../../../../../../lib/axios/FoodifoxDataAPI';
import Logo from '../../../../../Common/Logo';
import Location from '../../../../../Common/Location';
import PickupCode from '../../../../../Common/PickupCode';
import NetworkErrorModal from '../../../../../Common/NetworkErrorModal';

const OpenBox: FC<Props> = ({
  cabId32Str,
  setTargetPage,
  isEnglish,
  setIsEnglish,
  setShowLoading,
  cab,
  setOpenedBoxes,
  setOrderId,
  setPickupCode,
  userId,
  selectedPlatform,
  setSelectedPlatform,
}) => {
  const [checkPickupCodeLazy, { loading: checkCodeLoading }] = getFoodifoxDataLazy<number>('/foxH5Check/checkPickupCodeIsValid');
  const [openBoxLazy, { loading: openBoxLoading }] = updateFoodifoxData<{ openBoxes: Box[]; orderId: number }>('/foxH5Take/openBoxByOpenCode');

  const [codeNum, setCodeNum] = useState<string>();
  const [codeIsChecked, setCodeIsChecked] = useState<boolean>(false);
  const [showNetworkErrorModal, setShowNetworkErrorModal] = useState<boolean>();

  useEffect(() => {
    setShowLoading(checkCodeLoading || openBoxLoading);

    return () => {
      setShowLoading(false);
    };
  }, [checkCodeLoading, openBoxLoading]);

  /**
   * 开柜门取餐
   */
  const openBox = () => {
    if (!codeNum) {
      return;
    }

    openBoxLazy({
      param: {
        cabId: cabId32Str,
        userId,
        openCode: codeNum,
        platform: selectedPlatform,
      },
      onError(e) {
        if (e.message.includes('Cabinet is offline')) {
          setShowLoading(false);
          setPickupCode(codeNum);
          setTargetPage('offline-code-open-box');
        }
        else if (e.message.includes('The cabinet has no network')) {
          setShowNetworkErrorModal(true);
        }
      },
      onCompleted({ openBoxes, orderId }) {
        setOpenedBoxes(openBoxes);
        setOrderId(orderId);
        setPickupCode(codeNum);
        setTargetPage('user-open-box-success');
      },
    });
  };

  return (
    <BackgroundImage>
      {
        showNetworkErrorModal && (
          <NetworkErrorModal isEnglish={isEnglish} onClose={() => setShowNetworkErrorModal(false)} />
        )
      }
      {/* 头部 */}
      <Header
        isEnglish={isEnglish}
        setIsEnglish={setIsEnglish}
        style={{ marginTop: '50px' }}
        setTargetPage={setTargetPage}
      />

      {/* Logo */}
      <Logo setTargetPage={setTargetPage} backToPage={'select-platform'} clearPlatform={setSelectedPlatform} />

      {/* 地点 */}
      <Location isEnglish={isEnglish} cab={cab} style={{ marginTop: '25px' }} />

      {/* 描述 */}
      <div style={{ marginTop: '40px', width: '314px', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto' }}>
        {
          isEnglish ? (
            <div style={{ fontSize: '16px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '25px' }}>
              Please enter the <br /><span style={{ fontFamily: 'Squad-Bold', fontSize: '20px' }}>Pickup Code</span>
            </div>
          ) : (
            <div style={{ fontSize: '20px', fontFamily: 'PingFangSC-Regular, PingFang SC', color: '#11202B', lineHeight: '25px' }}>
              输入取餐码
            </div>
          )
        }
      </div>

      {/* 取餐码 */}
      <div style={{ marginTop: '40px', width: '314px', padding: '0 19px', marginLeft: 'auto', marginRight: 'auto' }}>
        <PickupCode
          callback={(pickupCode) => {
            setCodeNum(pickupCode);
            checkPickupCodeLazy({
              param: {
                cabId: cabId32Str,
                pickupCode,
                platform: selectedPlatform,
              },
              onCompleted() {
                setCodeIsChecked(true);
              },
            });
          }}
        />
      </div>

      {/* 打开柜门按钮 */}
      <Button
        disabled={!codeIsChecked}
        onClick={() => openBox()}
        style={{ width: '114px', height: '114px', borderRadius: '50%', border: codeIsChecked ? '2px solid #11202B' : undefined, background: codeIsChecked ? '#01B596' : '#D0D0D0', marginLeft: 'auto', marginRight: 'auto', marginTop: '50px' }}
      >
        {
          isEnglish ? (
            <div style={{ fontSize: '25px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '33px' }}>
              Open
            </div>
          ) : (
            <div style={{ fontSize: '22px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '36px' }}>
              取餐
            </div>
          )
        }
      </Button>

      <div
        style={{ marginTop: 28, textAlign: 'center', height: 45, cursor: 'pointer' }}
        onClick={() => {
          setTargetPage('support');
        }}
      >
        {
          isEnglish ? (
            <div style={{ fontSize: 18, fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#00B595', lineHeight: '24px', textDecoration: 'underline' }}>
              Get assistance here
            </div>
          ) : (
            <div style={{ fontSize: 18, fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#00B595', lineHeight: '25px', textDecoration: 'underline' }}>
              无法开柜？
            </div>
          )
        }
      </div>
    </BackgroundImage>
  );
};

export interface Props {
  cabId32Str: string;
  setTargetPage: (targetPage: string) => void;
  isEnglish: boolean;
  setIsEnglish: (isEng: boolean) => void;
  setShowLoading: (isShow: boolean) => void;
  cab: Cab,
  setOpenedBoxes: (openedBoxes: Box[]) => void;
  setOrderId: (orderId: number) => void;
  setPickupCode: (code: string) => void;
  userId: number;
  selectedPlatform: number;
  setSelectedPlatform: (platform?: number) => void;
}

export default OpenBox;
